import React from "react"
import {Link} from "gatsby"
import PropTypes from "prop-types"

import "./style.scss"

const Footer = ({siteTitle}) => (
  <footer className="main-footer container">
    <div>
      Copyright {new Date().getFullYear()} {siteTitle}{" "}
      <span className="dot">·</span>{" "}
      <span className="footer-links">
        <Link to="/privacy-policy">Privacy Policy</Link>
        {" | "}
        <Link to="/cookie-policy">Cookie Policy</Link>
        {" | "}
        <Link to="/terms-of-service">Terms of Service</Link>
      </span>
    </div>
  </footer>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

export default Footer
